module.exports = "/fonts/vendor/@fortawesome/fontawesome-free/webfa-v4compatibility.ttf?f601162ae669f88823a32a6928d1a528";